/* SQ Resultados — FAQ accordion */

// FAQ accordion
document.querySelectorAll('.sq-resultados-faq .faq-question').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var item = btn.parentElement;
    var isOpen = item.classList.contains('is-open');

    document.querySelectorAll('.sq-resultados-faq .faq-item').forEach(function (i) {
      i.classList.remove('is-open');
      i.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});